export interface TieredCommission {
  Rows: TieredCommissionRow[];
  TieredSystemType: TieredSystemType;
}

export interface TieredCommissionRow {
  id?: string;
  Order: number;
  LowerBound: number;
  UpperBound?: number;
  PercentageWithinBound: number;
}

export enum TieredSystemType {
  SingleRate = 'SingleRate',
  MultiRate = 'MultiRate',
}
